var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tab == 'story')?_c('StoryTab',{attrs:{"mode":_vm.mode},on:{"changeTab":_vm.changeTab}}):_c('StandardTab',{attrs:{"mode":_vm.mode},on:{"changeTab":_vm.changeTab}})}
var staticRenderFns = []

export { render, staticRenderFns }